export function hexToRGB(hex: string, alpha?: number): string {
  const r = parseInt(hex.slice(1, 3), 16)
  const g = parseInt(hex.slice(3, 5), 16)
  const b = parseInt(hex.slice(5, 7), 16)
  if (alpha) {
    return `rgba(${r}, ${g}, ${b}, ${alpha})`
  }
  return `rgb(${r}, ${g}, ${b})`
}

export function colorIsDark(color: string): boolean {
  if (!color) return false
  const hex = color.replace('#', '')
  const r = parseInt(hex.substr(0, 2), 16)
  const g = parseInt(hex.substr(2, 2), 16)
  const b = parseInt(hex.substr(4, 2), 16)
  const brightness = (r * 299 + g * 587 + b * 114) / 1000
  return brightness < 128
}

export function lighten(color: string, amount: number): string {
  const clamp = (val: number) => Math.min(255, Math.max(0, val))
  const num = parseInt(color.replace('#', ''), 16)
  const r = clamp((num >> 16) + amount)
  const g = clamp(((num >> 8) & 0x00ff) + amount)
  const b = clamp((num & 0x0000ff) + amount)
  return `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)}`
}

export function mix(color1: string, color2: string, weight: number): string {
  const hex = (c: string) => parseInt(c.replace('#', ''), 16)
  const p1 = hex(color1)
  const p2 = hex(color2)
  const w = (x: number) => Math.round(x * weight)
  const r = w((p1 >> 16) & 0xff) + w((p2 >> 16) & 0xff)
  const g = w((p1 >> 8) & 0xff) + w((p2 >> 8) & 0xff)
  const b = w(p1 & 0xff) + w(p2 & 0xff)
  return `#${((1 << 24) + (Math.min(r, 255) << 16) + (Math.min(g, 255) << 8) + Math.min(b, 255)).toString(16).slice(1)}`
}
